// Relative "Nm ago" text for <time datetime> elements, refreshed every minute.
function refresh() {
  document.querySelectorAll("time[datetime]").forEach((el) => {
    const dt = new Date(el.getAttribute("datetime"));
    if (Number.isNaN(dt.getTime())) return;
    const now = new Date();
    const diff = Math.floor((now - dt) / 1000);
    if (diff < 0) return;
    if (diff < 60) el.textContent = "just now";
    else if (diff < 3600) el.textContent = `${Math.floor(diff / 60)}m ago`;
    else if (diff < 86400) el.textContent = `${Math.floor(diff / 3600)}h ago`;
    else if (diff < 2592000) el.textContent = `${Math.floor(diff / 86400)}d ago`;
    // >30d: leave as server-rendered date string
  });
}
refresh();
setInterval(refresh, 60000);
